import StandardTabPanel from "../../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../../components/ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "all-docs",
      name: "All Docs",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/documents/all-docs`,
    },
    {
      key: "folders",
      name: "Folders",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/documents/folders`,
    },
  ];

  return (
    <StandardTabPanel
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="min-h-[90vh] p-4">{children}</section>
    </StandardTabPanel>
  );
}
